import { createTheme } from '@mui/material/styles';

// Ayu Dark inspired theme
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#39BAE6', // Ayu blue
      light: '#59C2FF',
      dark: '#1A6B99',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FFB454', // Ayu orange
      light: '#FFCC80',
      dark: '#FF8F00',
      contrastText: '#000000',
    },
    background: {
      default: '#0A0E14', // Ayu dark background
      paper: '#1F2430',   // Slightly lighter than background
    },
    text: {
      primary: '#E6E1CF',
      secondary: '#B3B1AD',
    },
    error: {
      main: '#FF3333', // Ayu red
    },
    warning: {
      main: '#E7C547', // Ayu yellow
    },
    info: {
      main: '#39BAE6', // Ayu blue
    },
    success: {
      main: '#A6CC70', // Ayu green
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 500,
    },
    h2: {
      fontWeight: 500,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1F2430',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#1F2430',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: '#131721',
          },
          '&:hover': {
            backgroundColor: '#253340',
          },
        },
      },
    },
  },
});

// Light theme based on similar color palette
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0B6E99', // Darker blue for light theme
      light: '#39BAE6',
      dark: '#064B6B',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FF8F00', // Orange
      light: '#FFB454',
      dark: '#C67100',
      contrastText: '#000000',
    },
    background: {
      default: '#F5F5F5', // Light background
      paper: '#FFFFFF',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
    error: {
      main: '#D32F2F',
    },
    warning: {
      main: '#FFA000',
    },
    info: {
      main: '#0288D1',
    },
    success: {
      main: '#388E3C',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 500,
    },
    h2: {
      fontWeight: 500,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: '#212121',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#F5F5F5',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: '#FAFAFA',
          },
          '&:hover': {
            backgroundColor: '#EEEEEE',
          },
        },
      },
    },
  },
});

export default darkTheme;
